import { ArrowRight, ShieldCheck, Star, Zap } from 'lucide-react';
import { COMPANY } from '../mock/data';

export default function Hero() {
  return (
    <section id="home" className="relative min-h-[100svh] flex items-end pb-16 pt-40 overflow-hidden bg-ink">
      {/* Cinematic dusk background */}
      <div className="absolute inset-0 z-0">
        <img
          src="/gallery/01-hero-dusk-pool.jpg"
          alt="Fence at dusk"
          className="w-full h-full object-cover"
        />
        {/* Cinematic gradients */}
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/40" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink/95 via-ink/50 to-transparent" />
        {/* Warm sunset glow */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_75%_60%,rgba(212,161,58,0.18),transparent_55%)]" />
        {/* Subtle grain */}
        <div className="absolute inset-0 opacity-[0.06] mix-blend-overlay pointer-events-none" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 200 200\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'a\'%3E%3CfeTurbulence baseFrequency=\'.9\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23a)\'/%3E%3C/svg%3E")' }} />
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 w-full grid lg:grid-cols-12 gap-8 lg:gap-12 items-end relative z-10">
        {/* Left copy */}
        <div className="lg:col-span-7 text-cream">
          <div className="inline-flex items-center gap-2 rounded-md border border-gold/40 bg-black/40 backdrop-blur px-3 py-1.5 mb-6 text-[11px] uppercase tracking-[0.25em] text-cream">
            <span className="w-1.5 h-1.5 rounded-full bg-gold" />
            Shreveport, LA Fence Contractor — Free Estimates
          </div>

          <h1 className="font-display text-6xl sm:text-7xl lg:text-[92px] leading-[0.95] tracking-tight uppercase">
            <span className="block text-cream drop-shadow-[0_2px_8px_rgba(0,0,0,0.5)]">Your Fence.</span>
            <span className="block text-gold drop-shadow-[0_2px_8px_rgba(0,0,0,0.5)]">Done Right.</span>
            <span className="block mt-1">
              <span className="text-cream drop-shadow-[0_2px_8px_rgba(0,0,0,0.5)]">Done </span>
              <span className="relative inline-block align-baseline">
                <span className="absolute inset-x-[-6px] inset-y-[10%] bg-gold -skew-x-[6deg]" aria-hidden="true" />
                <span className="relative text-ink px-2">BETTER.</span>
              </span>
            </span>
          </h1>

          <p className="mt-7 max-w-xl text-cream/85 text-base sm:text-lg leading-relaxed">
            Shreveport&rsquo;s trusted fence contractor. Expert installation for homes and businesses across the ArkLaTex &mdash; wood, vinyl, chain-link, iron, and custom decks. Request your free quote within 30 seconds.
          </p>

          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3 text-sm text-cream/85">
            <div className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-gold" /> Fully Insured</div>
            <div className="flex items-center gap-2"><Zap className="w-4 h-4 text-gold" /> Fast Response</div>
            <div className="flex items-center gap-2"><Star className="w-4 h-4 text-gold fill-gold" /> Quality Guaranteed</div>
          </div>
        </div>

        {/* Right quote card */}
        <div className="lg:col-span-5">
          <div className="rounded-md bg-ink-panel/90 backdrop-blur border border-white/10 p-6 lg:p-8 shadow-2xl">
            <div className="text-[11px] uppercase tracking-[0.25em] text-gold font-semibold">Request a quote</div>
            <h2 className="mt-2 font-display text-3xl lg:text-4xl uppercase text-cream leading-tight">Get your free fencing quote</h2>
            <div className="mt-3 text-sm text-cream/70">
              Fast response &middot; No obligation &middot; 100% free
            </div>

            <a href="#quote" className="mt-6 flex items-center justify-center gap-2 w-full bg-gold text-ink font-bold uppercase tracking-wider py-4 rounded-md hover:bg-gold-light transition-colors">
              Get Your Quote
              <ArrowRight className="w-4 h-4" />
            </a>

            <div className="mt-4 text-center text-xs text-cream/60">
              or call <a href={`tel:${COMPANY.phoneRaw}`} className="text-gold hover:text-gold-light font-semibold">{COMPANY.phone}</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
